import React from "react";
import { Button, useMediaQuery } from "@mui/material";

const BoutonPartagerListeWhatsApp = ({
  groupeActif,
  nomGroupe,
  urlListe,
  t,
  setSnackbar
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleClick = () => {
    if (!groupeActif?.lienWhatsApp) {
      setSnackbar({
        open: true,
        message: "Aucun groupe WhatsApp n’est lié à ce groupe.",
        severity: "warning"
      });
      return;
    }

    const message =
      `👋 ${t("WhatsAppSurveyGreeting")}\n\n` +
      `Voici la liste du groupe ${nomGroupe}.\n\n` +
      `${t("WhatsAppListInvitation").replace("{{nomGroupe}}", nomGroupe)}\n\n` +
      `👉 ${urlListe}`;

    const whatsappUrl =
      `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      sx={{
        backgroundColor: "#4CAF50",
        color: "#fff",
        fontWeight: "bold",
        fontSize: isMobile ? "0.5rem" : "0.7rem",
        padding: "10px 20px",
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "#128C7E"
        }
      }}
    >
      📱 {t("ShareListWhatsApp")}
    </Button>
  );
};

export default BoutonPartagerListeWhatsApp;